import { CommentCardProps } from "../files-comments-manage/files-comments-interface";
import styleSheet from "./style.module.scss";

const CommentCard = ({ comment }: CommentCardProps) => {
  // const FormattedComment = (text: string) => {
  //   const mentionMatch = text.match(/@\w+(?:\s\w+)*/);
  
  //   if (mentionMatch) {
  //     const mention = mentionMatch[0];
  //     const before = text.slice(0, mentionMatch.index);
  //     const after = text.slice(mentionMatch.index! + mention.length);
  
  //     return (
  //       <>
  //         <span className="opacity-50 m-0 text-white">{before}</span>
  //         <span className="text-white m-0">{mention}</span>
  //         <span className="opacity-50 m-0 text-white">{after}</span>
  //       </>
  //     );
  //   }
  
  //   return <span className="opacity-50 m-0 text-white">{text}</span>;
  // };
  
  return (
    <div className={`${styleSheet.comment_card} d-flex py-1 rounded-3 px-1`}>
      <p
        className="text-wrap text-white sub-font mohave-bold m-0"
        // dangerouslySetInnerHTML={{ __html: FormattedComment(comment) }}
      >   <span className="opacity-50 m-0 text-white">{comment}</span></p>
    </div>
  );
};

export default CommentCard;
